// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wji6","content":"styles_content__3Wk7D"};